import { css } from 'lit';

/*
This file is reserved for any custom css that developers want to add to
customize their theme. Simply add your css to this file and yarn build.
*/

export default css`
.expanded-req-resp-container{
    display: flex;
    width: 100%;
    justify-content: space-between;
}
.expanded-req-resp-container-schema{
    border-right: 1px solid var(--code-data-color);
    padding: 0px 24px 24px 24px;
    width: 50%;
}
.expanded-req-resp-container-main-request{
    width: 50%;
    padding: 0px 24px 24px 24px;
}
.response-panel.read-mode{
    border-top: unset;
    margin-top: 0px;
}
.response-card{
    max-height: 300px;
    overflow-y: auto;
    background-color: #343536;
    color: var(--code-data-color);
    border: none;
}
.nav-bar-path.active{
    color: #177CDA;
}
.nav-bar-path:hover{
    color: #ffffff;
}
.textarea{
    background-color: #343536;
    color: var(--code-data-color);
    border: none;
}
.m-markdown pre{
    background-color: #343536;
    color: var(--code-data-color);
    border: none;
}
.object{
    color: unset;
}
.token.punctuation{
    color: var(--code-data-color);
}
.token.operator{
    color: var(--code-data-color);
}
.token.property{
    color: var(--code-data-color);
}
.token.string{
    color: #C3E88D;
}
.string{
   color: #C3E88D;
}
`;
